// Thin app-local bridge between the shared @mayline-ai/platform-ui SignInCard and
// the admin dashboard's app-owned login redirect (unified-auth U2).
//
// The shared SignInCard is presentational-only (UI-2): it emits typed provider
// intents and owns NO redirect/CSRF/fetch logic. This bridge maps those intents
// onto the dashboard's existing app-local `redirectToLogin(returnUrl, provider)`
// (which keeps the /connect/login proxy + session CSRF app-local), forwarding the
// chosen provider end-to-end so the two buttons are functionally distinct. It
// mirrors SalesTrainer's identical signin-bridge: no behaviour beyond wiring the
// host's own action.

import { redirectToLogin } from './auth';
import type { SignInProvider } from '@mayline-ai/platform-ui';

/**
 * Build the SignInCard's `onMicrosoft`/`onGoogle` handlers, both bound to the
 * caller's post-login destination. Each handler forwards the chosen provider to
 * the app-local redirect; the SignInCard supplies the concrete provider value,
 * but we ignore the callback arg and use the fixed provider per button so a
 * caller can't be coerced into the wrong IdP.
 */
export function createSignInHandlers(returnUrl?: string): {
  onMicrosoft: (provider?: SignInProvider) => void;
  onGoogle: (provider?: SignInProvider) => void;
} {
  return {
    onMicrosoft: () => redirectToLogin(returnUrl, 'microsoft'),
    onGoogle: () => redirectToLogin(returnUrl, 'google'),
  };
}
